import { IconPaths, ModalSize } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { UsuarioCreateModal } from '../modal/UsuarioCreateModal'
import { usePermissaoUsuarioCreate } from '../../core/_usuarioPermissao'

export const UsuariosListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()
  const podeCriar = usePermissaoUsuarioCreate()

  if (!podeCriar) return null

  const openModal = () =>
    showModal({
      title: t('modal.novo_usuario'),
      content: <UsuarioCreateModal />,
      size: ModalSize.ExtraLarge,
    })

  return (
    <Button onClick={openModal} icon={IconPaths.Add} className='btn-primary'>
      {t('usuario.novo')}
    </Button>
  )
}
